export default function CTASection() {
  return (
    <section id="cta" className="py-20 md:py-32 px-6 bg-white relative overflow-hidden">
      {/* Washi Texture */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' /%3E%3C/filter%3E%3Crect width='100' height='100' filter='url(%23noise)' opacity='0.4'/%3E%3C/svg%3E")`,
        }}
      ></div>

      <div className="max-w-4xl mx-auto text-center relative">
        <h2 className="font-serif text-4xl md:text-5xl font-bold text-forest-800 mb-4">
          ご予約・お問い合わせ
        </h2>
        <p className="text-gray-700 text-lg mb-12">
          まずはお気軽にご相談ください
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-16">
          <a
            href="tel:079-667-8119"
            className="inline-flex items-center px-10 py-4 bg-forest-800 text-white text-base md:text-lg font-medium rounded-full hover:bg-forest-900 transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
          >
            <i className="ri-phone-fill mr-3 text-xl"></i>
            電話で予約
          </a>
          <div className="inline-flex items-center px-10 py-4 bg-gold-600 text-white text-base md:text-lg font-medium rounded-full hover:bg-gold-700 transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg">
            <i className="ri-printer-fill mr-3 text-xl"></i>
            FAXで予約
          </div>
        </div>

        {/* Contact Info Cards */}
        <div className="grid md:grid-cols-2 gap-6 mb-12">
          <div className="bg-forest-50 rounded-2xl p-8">
            <div className="w-12 h-12 flex items-center justify-center bg-forest-800 rounded-full mx-auto mb-4">
              <i className="ri-phone-line text-white text-2xl"></i>
            </div>
            <h3 className="font-semibold text-forest-800 mb-2 text-lg">お電話でのご予約</h3>
            <a
              href="tel:079-667-8119"
              className="text-2xl font-bold text-gold-600 hover:text-gold-700 transition-colors cursor-pointer"
            >
              079-667-8119
            </a>
            <p className="text-gray-600 text-sm mt-2">受付時間：9:00〜19:00</p>
          </div>

          <div className="bg-forest-50 rounded-2xl p-8">
            <div className="w-12 h-12 flex items-center justify-center bg-forest-800 rounded-full mx-auto mb-4">
              <i className="ri-printer-line text-white text-2xl"></i>
            </div>
            <h3 className="font-semibold text-forest-800 mb-2 text-lg">FAXでのご予約</h3>
            <p className="text-2xl font-bold text-gold-600">079-667-8158</p>
            <p className="text-gray-600 text-sm mt-2">24時間受付</p>
          </div>
        </div>

        {/* Image Banner */}
        <div className="grid grid-cols-3 gap-4">
          <div className="w-full h-[200px] rounded-xl overflow-hidden shadow-lg">
            <img
              src="https://static.readdy.ai/image/cc91b7789a14262b14655463cd9fff45/a5b827536b19fdf72e762e3ac821d7e0.jpeg"
              alt="和室"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="w-full h-[200px] rounded-xl overflow-hidden shadow-lg">
            <img
              src="https://public.readdy.ai/ai/img_res/a0c0a419a5ebe3280aea0b21fc5725fa.jpg"
              alt="料理"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="w-full h-[200px] rounded-xl overflow-hidden shadow-lg">
            <img
              src="https://readdy.ai/api/search-image?query=Beautiful%20Hachi%20Kogen%20mountain%20landscape%20with%20lush%20green%20forest%2C%20rolling%20hills%2C%20clear%20blue%20sky%2C%20peaceful%20Japanese%20highland%20scenery%20with%20natural%20beauty%2C%20serene%20outdoor%20environment%20perfect%20for%20relaxation&width=400&height=500&seq=cta3&orientation=portrait"
              alt="はち高原の自然"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}